import { BackToTopIcon } from '@kohler-dsm-library/kohler-icons';

export const enhancePaginationConfig = (
  config,
  perPage,
  handlePerPageClick,
  handleLoadMoreClick,
  handleBackToTop,
) => {
  return {
    ...config,

    currentPerPage: perPage,

    perPageCTAs: config.perPageCTAs?.map((cta) => ({
      ...cta,
      onClick: () => {
        if (typeof handlePerPageClick === 'function') {
          handlePerPageClick(cta.value);
        }
      },
    })),

    loadMoreCTA: config.loadMoreCTA
      ? {
          ...config.loadMoreCTA,
          onClick: () => {
            if (typeof handleLoadMoreClick === 'function') {
              handleLoadMoreClick();
            }
          },
        }
      : undefined,

    backToTopCTA: config.backToTopCTA
      ? {
          ...config.backToTopCTA,
          icon: BackToTopIcon,
          onClick: () => {
            if (typeof handleBackToTop === 'function') {
              handleBackToTop();
            }
          },
        }
      : undefined,
  };
};
